import "core-js/modules/es.array.is-array";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";

/*
 * Copyright (c) 2018 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
import { getClasses } from '../style-utils/style-utils';

var getIconClasses = function getIconClasses() {
  var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return typeof classes === 'function' ? classes() : Array.isArray(classes) ? classes : classes.split(' ');
};

export default (function (_ref) {
  var styles = _ref.styles,
      classes = _ref.classes,
      className = _ref.className,
      brand = _ref.brand,
      device = _ref.device;
  return getClasses({
    styles: styles,
    classes: getIconClasses(classes),
    className: className,
    brand: brand,
    device: device
  });
});